import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";

import QnA from "../../models/qna.model";
import { QnAService } from "../../services/qna.service";

import * as _ from "lodash";
import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";

@Component({
  selector: "ngx-dialog-qna-content",
  templateUrl: "dialog-qna-content.component.html",
  styleUrls: ["dialog-qna-content.component.scss"],
})
export class DialogQnAContentComponent implements OnInit {
  @Input() header: string;
  @Input() mode: string;
  @Input() qna: QnA = new QnA();

  status: string = "0";
  trees: Set<string> = new Set([]);
  qnaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  imagesUrl = [];

  constructor(
    protected ref: NbDialogRef<DialogQnAContentComponent>,
    private fb: FormBuilder,
    private qnaService: QnAService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    const titleValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];

    const descriptionValidators = [
      Validators.minLength(3),
      Validators.maxLength(500),
      Validators.required,
    ];

    this.qnaForm = this.fb.group({
      title: ["", titleValidators],
      description: ["", descriptionValidators],
      sourceType: [Validators.required],
      privacy: [Validators.required],
      content: [],
      url: [],
    });

    if (this.qna.tags && this.qna.tags.length > 0) {
      var trees = new Set([]);
      this.qna.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("Q&A");
    }
    if (!this.qna.sourceType) {
      this.qna.sourceType = "document";
    }
    if (!this.qna.status) {
      this.status = "0";
    } else {
      this.status = this.qna.status.toString();
    }
    if (this.qna.imagesUrl && this.qna.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.qna.imagesUrl);
    }
    if (!this.qna.content) {
      this.qna.content = "";
    }
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.qna);
    } else {
      this.ref.close();
    }
  }

  submit() {
    this.submitted = true;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.qna.tags = tags;
    this.qna.status = parseInt(this.status);

    if (this.mode == "edit") {
      this.editQnA();
    } else {
      this.createQnA();
    }
  }

  createQnA() {
    this.loading = true;
    this.submitted = true;

    this.qnaService
      .createQnA(this.qna)
      .then((data) => {
        this.qna = data;

        this.loading = false;
        this.submitted = false;

        this.ref.close(this.qna);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  editQnA() {
    this.loading = true;
    this.submitted = true;

    this.qnaService
      .updateQnA(this.qna)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        //this.ref.close(this.qna);
        this.edited = true;
        this.showToast("success", "Cập nhật bài viết", "thành công");
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật bài viết", "thất bại");
      });
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.qna.imagesUrl) {
      this.qna.imagesUrl = [];
    }
    this.qna.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    _.remove(this.qna.imagesUrl, (el) => {
      return el == item;
    });
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value.trim().toUpperCase());
    }
    input.nativeElement.value = "";
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
